import { render } from "./InputSpinnerScale.vue?vue&type=template&id=080af96c&scoped=true&ts=true"
import script from "./InputSpinnerScale.vue?vue&type=script&lang=ts"
export * from "./InputSpinnerScale.vue?vue&type=script&lang=ts"

import "./InputSpinnerScale.vue?vue&type=style&index=0&id=080af96c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-080af96c"]])

export default __exports__